import { c as _c } from "react/compiler-runtime";
import { BlogsIcon, ContactIcon, CourseIcon, FunnelIcon, StoreIcon, MoneyBillTransferIcon } from '@systemeio/ui/icons';
import { FormInput, Hint, centsToUnits } from '@systemeio/ui';
import { replaceWwwForHosts } from '@systemeio/util';
import { DetailsList } from 'modules/subaccounts/components/details-list';
import { subAccountDefaultCreateValues, subAccountDefaultErrors } from 'modules/subaccounts/constants/sub-account-default-values';
import { SubAccountsLoco } from 'modules/subaccounts/constants/sub-accounts-loco';
import { useSubAccounts } from 'modules/subaccounts/hooks/use-sub-accounts';
import { useSubAccountsActions } from 'modules/subaccounts/hooks/use-sub-accounts-actions';
import { SubAccountCreateInterface, SubAccountErrorsInterface, SubAccountInterface } from 'modules/subaccounts/types/sub-account-interface';
import { getSubAccountNewLeadsStatistics } from 'modules/subaccounts/utils/get-sub-account-new-leads-statistics';
import { findResourceByUserId } from 'modules/subaccounts/utils/get-sub-account-resources';
import { getSubAccountSalesStatistics } from 'modules/subaccounts/utils/get-sub-account-sales-statistics';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { generatePretendUserUrl } from 'shared/hooks/use-user/utils/generate-pretend-user-url';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { currencyFormat } from 'shared/utils/currency-format';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps, getCombinedServerSideProps } from 'shared/utils/get-base-server-side-props';
import { generatePathFromName } from 'shared/utils/path-utils';
import { isClient } from 'shared/components/screen-height-div';
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts';
const iconProps = {
  width: 20,
  height: 20,
  className: 'fill-text-secondary'
};
function SubAccounts() {
  const $ = _c(126);
  const {
    t,
    tICU
  } = useLocoTranslation();
  const {
    user,
    mutate: mutateUser,
    shouldShowSubAccountPage
  } = useUser();
  const router = useRouter();
  const {
    deleteSubAccount,
    createSubAccount,
    editSubAccount
  } = useSubAccountsActions();
  const [errors, setErrors] = useState(subAccountDefaultErrors);
  let t0;
  if ($[0] !== router || $[1] !== shouldShowSubAccountPage || $[2] !== user) {
    t0 = () => {
      if (!user) {
        return;
      }
      if (!shouldShowSubAccountPage) {
        router.push("/403");
      }
    };
    $[0] = router;
    $[1] = shouldShowSubAccountPage;
    $[2] = user;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== shouldShowSubAccountPage || $[5] !== user) {
    t1 = [shouldShowSubAccountPage, user];
    $[4] = shouldShowSubAccountPage;
    $[5] = user;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  let t2;
  if ($[7] !== limit || $[8] !== pagination) {
    t2 = {
      pagination,
      limit
    };
    $[7] = limit;
    $[8] = pagination;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const {
    subAccounts,
    counter,
    mutate,
    resources,
    isLoadingResources,
    sales,
    isLoadingSales,
    newLeads,
    isLoadingNewLeads,
    revalidateSubAccountsModule
  } = useSubAccounts(t2);
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setErrors(subAccountDefaultErrors);
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onModalClose = t3;
  let t4;
  if ($[11] !== t) {
    t4 = t("global.name");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = {
      key: "name",
      header: t4,
      onRender: _temp,
      widthPercent: 20
    };
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t) {
    t6 = t("dashboard.sub_accounts.resources");
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isLoadingResources || $[18] !== resources?.items || $[19] !== t || $[20] !== user?.dateFormat || $[21] !== user?.timeFormat || $[22] !== user?.timezone) {
    t7 = subAccount_0 => {
      const data = findResourceByUserId(subAccount_0.user.id, resources?.items);
      if (isLoadingResources) {
        return <div className="bg-skeleton-primary rounded-xs animate-pulse py-2.5" />;
      }
      if (!data) {
        return null;
      }
      const resourcesList = [<><span>{t("global.created_on")}:</span><span className="truncate" title={dateTimeFormat(data.user.createdAt, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}>{dateTimeFormat(data.user.createdAt, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })}</span></>, <><ContactIcon {...iconProps} /><span>{data.contacts}</span>{t("dashboard.sub_accounts.contacts")}</>, <><FunnelIcon {...iconProps} /><span>{data.funnels}</span>{t("dashboard.sub_accounts.funnels")}</>, <><BlogsIcon {...iconProps} /><span>{data.blogs}</span>{t("dashboard.sub_accounts.blogs")}</>, <><CourseIcon {...iconProps} /><span>{data.courses}</span>{t("dashboard.sub_accounts.courses")}</>, <><StoreIcon {...iconProps} /><span>{data.digitalStores}</span>{t("dashboard.sub_accounts.digital_stores")}</>];
      return <DetailsList rows={resourcesList} />;
    };
    $[17] = isLoadingResources;
    $[18] = resources?.items;
    $[19] = t;
    $[20] = user?.dateFormat;
    $[21] = user?.timeFormat;
    $[22] = user?.timezone;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = {
      key: "resources",
      header: t6,
      onRender: t7,
      widthPercent: 20
    };
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t) {
    t9 = t("dashboard.sub_accounts.last_30_days");
    $[27] = t;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t) {
    t10 = t("dashboard.sub_accounts.statistics");
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t10 || $[32] !== t9) {
    t11 = <Hint label={t9}>{t10}</Hint>;
    $[31] = t10;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== isLoadingNewLeads || $[35] !== isLoadingSales || $[36] !== newLeads?.items || $[37] !== sales?.items || $[38] !== t || $[39] !== user?.dashboardLocale) {
    t12 = subAccount_1 => {
      if (isLoadingSales || isLoadingNewLeads) {
        return <div className="bg-skeleton-primary rounded-xs animate-pulse py-2.5" />;
      }
      const statisticsList = [<><MoneyBillTransferIcon {...iconProps} /><div className="flex flex-col gap-1">{getSubAccountSalesStatistics(subAccount_1, sales?.items)?.sales.map(t13 => {
            const {
              currency,
              value
            } = t13;
            return <span key={currency}>{currencyFormat(centsToUnits(value), currency, user?.dashboardLocale)}</span>;
          })}</div>{t("dashboard.sub_accounts.sales")}</>, <><FunnelIcon {...iconProps} /><div className="flex flex-col gap-1">{getSubAccountNewLeadsStatistics(subAccount_1, newLeads?.items)?.newLeads}</div>{t("dashboard.sub_accounts.new_leads")}</>];
      return <DetailsList rows={statisticsList} />;
    };
    $[34] = isLoadingNewLeads;
    $[35] = isLoadingSales;
    $[36] = newLeads?.items;
    $[37] = sales?.items;
    $[38] = t;
    $[39] = user?.dashboardLocale;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t11 || $[42] !== t12) {
    t13 = {
      key: "statistics",
      header: t11,
      onRender: t12
    };
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== t13 || $[45] !== t5 || $[46] !== t8) {
    t14 = [t5, t8, t13];
    $[44] = t13;
    $[45] = t5;
    $[46] = t8;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  const columns = t14;
  let t15;
  if ($[48] !== createSubAccount || $[49] !== mutateUser || $[50] !== revalidateSubAccountsModule) {
    t15 = async subAccount_2 => {
      await fetchWithErrors(async () => {
        const newSubAccount = await createSubAccount(subAccount_2);
        revalidateSubAccountsModule(true);
        await mutateUser(data_0 => {
          if (!data_0) {
            return;
          }
          if (hasSubAccounts(data_0)) {
            return {
              ...data_0,
              subaccounts: [...data_0.subaccounts, newSubAccount]
            };
          } else {
            return {
              ...data_0,
              subaccounts: [newSubAccount]
            };
          }
        }, false);
      }, setErrors);
    };
    $[48] = createSubAccount;
    $[49] = mutateUser;
    $[50] = revalidateSubAccountsModule;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  const onCreate = t15;
  let t16;
  if ($[52] !== editSubAccount || $[53] !== mutate || $[54] !== mutateUser || $[55] !== revalidateSubAccountsModule) {
    t16 = async (oldData, updatedData) => {
      await fetchWithErrors(async () => {
        const returnedData = await editSubAccount(oldData.user.id, {
          name: updatedData.displayName
        });
        await mutate(data_1 => data_1 && {
          items: data_1.items.map(item => {
            if (item.id === oldData.id) {
              item = returnedData;
            }
            return item;
          }),
          hasMore: data_1.hasMore
        }, false);
        await mutateUser(data_2 => {
          if (!data_2 || !hasSubAccounts(data_2)) {
            return;
          }
          return {
            ...data_2,
            subaccounts: data_2.subaccounts.map(item_0 => {
              if (item_0.id === oldData.id) {
                return returnedData;
              }
              return item_0;
            })
          };
        }, false);
      }, setErrors);
      revalidateSubAccountsModule();
    };
    $[52] = editSubAccount;
    $[53] = mutate;
    $[54] = mutateUser;
    $[55] = revalidateSubAccountsModule;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  const onEdit = t16;
  let t17;
  if ($[57] !== deleteSubAccount || $[58] !== mutateUser || $[59] !== revalidateSubAccountsModule) {
    t17 = async subAccount_3 => {
      await deleteSubAccount(subAccount_3.user.id);
      revalidateSubAccountsModule(true);
      await mutateUser(data_3 => {
        if (!data_3 || !hasSubAccounts(data_3)) {
          return;
        }
        return {
          ...data_3,
          subaccounts: data_3.subaccounts.filter(item_1 => item_1.user.id !== subAccount_3.user.id)
        };
      }, false);
    };
    $[57] = deleteSubAccount;
    $[58] = mutateUser;
    $[59] = revalidateSubAccountsModule;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  const onRemove = t17;
  let t18;
  if ($[61] !== router) {
    t18 = subAccount_4 => {
      router.push(generatePretendUserUrl(subAccount_4.user.id));
    };
    $[61] = router;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  const onImpersonateSubAccount = t18;
  const t19 = counter?.count;
  let t20;
  if ($[63] !== t19 || $[64] !== tICU) {
    t20 = tICU("dashboard.sub_accounts.title_icu", {
      count: t19
    });
    $[63] = t19;
    $[64] = tICU;
    $[65] = t20;
  } else {
    t20 = $[65];
  }
  let t21;
  if ($[66] !== t) {
    t21 = t("dashboard.sub_account.title");
    $[66] = t;
    $[67] = t21;
  } else {
    t21 = $[67];
  }
  const t22 = !subAccounts;
  let t23;
  if ($[68] !== t) {
    t23 = t("dashboard.sub_account.toast_create");
    $[68] = t;
    $[69] = t23;
  } else {
    t23 = $[69];
  }
  let t24;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = ["name", "domain"];
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== errors || $[72] !== t) {
    t25 = {
      field: "name",
      onRender: (value_0, onChange) => <FormInput required={true} key="sub-account-name-create" label={t("global.name")} value={value_0} onChange={e => onChange(e.target.value)} error={errors.name} />
    };
    $[71] = errors;
    $[72] = t;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== errors || $[75] !== t) {
    t26 = {
      field: "domain",
      onRender: (value_1, onChange_0, state) => <FormInput required={true} key="sub-account-domain-create" label={t("dashboard.sub_accounts.sub_domain")} error={errors.domain} addonBefore={`${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://`} addonAfter={isClient() ? `.${replaceWwwForHosts(window.location.host)}` : undefined} onChange={e_0 => onChange_0(e_0.target.value)} onFocus={e_1 => {
        if (!e_1.target.value) {
          onChange_0(generatePathFromName(state.name));
        }
      }} value={value_1} />
    };
    $[74] = errors;
    $[75] = t;
    $[76] = t26;
  } else {
    t26 = $[76];
  }
  let t27;
  if ($[77] !== t25 || $[78] !== t26) {
    t27 = [t25, t26];
    $[77] = t25;
    $[78] = t26;
    $[79] = t27;
  } else {
    t27 = $[79];
  }
  let t28;
  if ($[80] !== onCreate || $[81] !== t21 || $[82] !== t22 || $[83] !== t23 || $[84] !== t27) {
    t28 = {
      defaultValues: subAccountDefaultCreateValues,
      onCreate,
      caption: t21,
      disabled: t22,
      toastCaption: t23,
      requiredFields: t24,
      creatable: t27
    };
    $[80] = onCreate;
    $[81] = t21;
    $[82] = t22;
    $[83] = t23;
    $[84] = t27;
    $[85] = t28;
  } else {
    t28 = $[85];
  }
  let t29;
  if ($[86] !== t) {
    t29 = t("dashboard.sub_account.title");
    $[86] = t;
    $[87] = t29;
  } else {
    t29 = $[87];
  }
  let t30;
  if ($[88] !== onRemove) {
    t30 = {
      onChange: onRemove
    };
    $[88] = onRemove;
    $[89] = t30;
  } else {
    t30 = $[89];
  }
  let t31;
  if ($[90] !== errors || $[91] !== t) {
    t31 = [{
      field: "displayName",
      onRender: (value_2, onChange_1) => <FormInput required={true} key="sub-account-display-name-edit" label={t("global.name")} value={value_2} onChange={e_2 => onChange_1(e_2.target.value)} error={errors.name} />
    }];
    $[90] = errors;
    $[91] = t;
    $[92] = t31;
  } else {
    t31 = $[92];
  }
  let t32;
  if ($[93] !== onEdit || $[94] !== t31) {
    t32 = {
      onEdit,
      onModalClose,
      editable: t31
    };
    $[93] = onEdit;
    $[94] = t31;
    $[95] = t32;
  } else {
    t32 = $[95];
  }
  let t33;
  if ($[96] !== t) {
    t33 = t("dashboard.sub_account.impersonate");
    $[96] = t;
    $[97] = t33;
  } else {
    t33 = $[97];
  }
  let t34;
  if ($[98] !== onImpersonateSubAccount) {
    t34 = instance => onImpersonateSubAccount(instance);
    $[98] = onImpersonateSubAccount;
    $[99] = t34;
  } else {
    t34 = $[99];
  }
  let t35;
  if ($[100] !== t33 || $[101] !== t34) {
    t35 = [{
      caption: t33,
      name: "impersonateToSubAccount",
      onActionClick: t34
    }];
    $[100] = t33;
    $[101] = t34;
    $[102] = t35;
  } else {
    t35 = $[102];
  }
  let t36;
  if ($[103] !== t30 || $[104] !== t32 || $[105] !== t35) {
    t36 = {
      remove: t30,
      settings: t32,
      custom: t35
    };
    $[103] = t30;
    $[104] = t32;
    $[105] = t35;
    $[106] = t36;
  } else {
    t36 = $[106];
  }
  let t37;
  if ($[107] !== limit || $[108] !== setLimit) {
    t37 = {
      limit,
      setLimit
    };
    $[107] = limit;
    $[108] = setLimit;
    $[109] = t37;
  } else {
    t37 = $[109];
  }
  let t38;
  if ($[110] !== pagination || $[111] !== setPagination) {
    t38 = {
      pagination,
      setPagination
    };
    $[110] = pagination;
    $[111] = setPagination;
    $[112] = t38;
  } else {
    t38 = $[112];
  }
  let t39;
  if ($[113] !== columns || $[114] !== subAccounts || $[115] !== t29 || $[116] !== t36 || $[117] !== t37 || $[118] !== t38) {
    t39 = <Table columns={columns} caption={t29} data={subAccounts} actions={t36} limiter={t37} paginator={t38} />;
    $[113] = columns;
    $[114] = subAccounts;
    $[115] = t29;
    $[116] = t36;
    $[117] = t37;
    $[118] = t38;
    $[119] = t39;
  } else {
    t39 = $[119];
  }
  let t40;
  if ($[120] !== counter || $[121] !== subAccounts || $[122] !== t20 || $[123] !== t28 || $[124] !== t39) {
    t40 = <ListingLayout counter={counter} type="compact" title={t20} data={subAccounts} createData={t28}>{t39}</ListingLayout>;
    $[120] = counter;
    $[121] = subAccounts;
    $[122] = t20;
    $[123] = t28;
    $[124] = t39;
    $[125] = t40;
  } else {
    t40 = $[125];
  }
  return t40;
}
function _temp(subAccount) {
  return <div className="flex items-center gap-2">{subAccount.profileImage && <img className="h-10 w-10 rounded-full object-cover" src={subAccount.profileImage.path} />}<div className="flex flex-col"><span>{subAccount.displayName}</span></div></div>;
}
export const getServerSideProps = getCombinedServerSideProps(getBaseServerSideProps(SubAccountsLoco, 'header.top_menu.sub_accounts'));
export default SubAccounts;